﻿export function setupFleet200Testimonials() {
    $('.fleet200-testimonials-slider').bxSlider({
        slideWidth: 0,
        minSlides: 1,
        maxSlides: 1,
        moveSlides: 1,
        slideMargin: 30,
        pager: false,
        pagerType: 'full',
        controls: true
    });
}